module.exports = __webpack_public_path__ + "static/slick-logo-e33f02764439d70ba62cb67214abb29a.png";